import { ApplicationListParams } from '../../model/application-list-params';
import * as enabledApplications from '../../actions/application-list.actions';
import { ActionReducer } from '@ngrx/store';
import { Globals } from '../../../../app.globals';

const initialState = new ApplicationListParams(0, Globals.itemsPerPage.common);

/**
 * Reducer manages paging parameters.
 */
export const enabledApplicationParams:
    ActionReducer<ApplicationListParams> = (state: ApplicationListParams = initialState, action: enabledApplications.Actions) => {
    switch (action.type) {
        case enabledApplications.CHANGE_PARAMS:
            return {...state, ...action.payload};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/applications/reducers/enabled-applicaton/enabled-application-params.reducer.ts